import { render, staticRenderFns } from "./Paginas.vue?vue&type=template&id=6948fe0c&scoped=true"
import script from "./Paginas.vue?vue&type=script&lang=js"
export * from "./Paginas.vue?vue&type=script&lang=js"
import style0 from "./Paginas.vue?vue&type=style&index=0&id=6948fe0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6948fe0c",
  null
  
)

export default component.exports